import { getCookie } from '../../utils/cookie';
import { MAINTENANCE_COOKIES_CHANGED, MAINTENANCE_DATE_TIME_KEY, MAINTENANCE_IS_RUNNING_KEY } from './const';
import { syncManager } from '../../utils/syncManager';

// Variables to store the previous values of the cookies
let previousMaintenanceIsRunning = null;
let previousMaintenanceDateTimeUtc = null;

export const interceptMaintenanceWork = () => {
	const maintenanceIsRunning = getCookie(MAINTENANCE_IS_RUNNING_KEY);
	const maintenanceDateTimeUtc = getCookie(MAINTENANCE_DATE_TIME_KEY);

	if (
		maintenanceIsRunning !== previousMaintenanceIsRunning ||
		maintenanceDateTimeUtc !== previousMaintenanceDateTimeUtc
	) {
		syncManager.emit('React', MAINTENANCE_COOKIES_CHANGED, {
			maintenanceIsRunning,
			maintenanceDateTimeUtc,
		});

		previousMaintenanceIsRunning = maintenanceIsRunning;
		previousMaintenanceDateTimeUtc = maintenanceDateTimeUtc;
	}
};

export function parseMaintenanceDateTime(dateTime: string) {
	const [datePart, timePart] = dateTime.split(' ');
	const [dayStr, monthStr, yearStr] = datePart.split('-');
	const [hourStr, minuteStr] = timePart.split(':');

	const day = parseInt(dayStr, 10);
	const month = parseInt(monthStr, 10) - 1;
	const year = parseInt(yearStr, 10);
	const hour = parseInt(hourStr, 10);
	const minute = parseInt(minuteStr, 10);

	return new Date(Date.UTC(year, month, day, hour, minute));
}

export function formatMaintenanceDate(date: Date) {
	return date.toLocaleDateString('nl-NL', {
		year: 'numeric',
		month: '2-digit',
		day: '2-digit',
	});
}

export function formatMaintenanceTime(date: Date) {
	return date.toLocaleTimeString('nl-NL', {
		hour: '2-digit',
		minute: '2-digit',
		hour12: false,
	});
}

export const formatMaintenanceDateTime = (dateTime: string) => {
	const dateObj = parseMaintenanceDateTime(dateTime);
	const date = formatMaintenanceDate(dateObj);
	const time = formatMaintenanceTime(dateObj);

	return `${date} ${time}`;
};

export function isMaintenanceDateInPast(maintenanceDateTimeUtc: string) {
	const maintenanceDate: Date = parseMaintenanceDateTime(maintenanceDateTimeUtc);
	const nowUtc: Date = new Date();

	return nowUtc.getTime() > maintenanceDate.getTime();
}

export function normalizeBoolean(value: string | null) {
	if (typeof value !== 'string') {
		return false;
	}

	const normalized = value.trim().toLowerCase();

	return normalized === 'true';
}
